import { createSlice } from "@reduxjs/toolkit";
import {
  createAlertAction,
  getAlertsAction,
  getAlertByIdAction,
  updateAlertAction,
  deleteAlertAction,
} from "../../actions/Alerts/AlertsAction";

const initialState = {
  alerts: [],
  alert: null,
  loading: false,
  error: null,
  success: false,
};

const alertsSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.alert = null;
    },
    setAlert: (state, action) => {
      state.alert = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAlertAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createAlertAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.alerts.unshift(action.payload);
      })
      .addCase(createAlertAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAlertsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAlertsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.alerts = action.payload;
      })
      .addCase(getAlertsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAlertByIdAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAlertByIdAction.fulfilled, (state, action) => {
        state.loading = false;
        state.alert = action.payload;
      })
      .addCase(getAlertByIdAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateAlertAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateAlertAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        const index = state.alerts.findIndex(
          (alert) => alert.alertID === action.payload.alertID,
        );
        if (index !== -1) {
          state.alerts[index] = action.payload;
        }
      })
      .addCase(updateAlertAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteAlertAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteAlertAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.alerts = state.alerts.filter(
          (alert) => alert.alertID !== action.payload.alertID,
        );
      })
      .addCase(deleteAlertAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetState, setAlert } = alertsSlice.actions;
export default alertsSlice.reducer;
